import React from 'react';
import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';

const ExportToolbar = () => (
  <GridToolbarContainer>
    <GridToolbarExport csvOptions={{ utf8WithBom: true }} />
  </GridToolbarContainer>
);

export default ExportToolbar;
